import { GameInfoMapped } from 'modules/overlay-v2/domain/interfaces/game-info/gameInfoMapped';
import { NewReceivedData } from 'modules/core/domain/interfaces/supabase/received-data';
import parseInfoEvent from 'modules/overlay-v2/store/game-info/utils/parse-info.event';

export async function updateFoulPeriods(gameInfo: GameInfoMapped, data: NewReceivedData) {
  if (!gameInfo.match) return;
  if (!gameInfo.teams) return;
  if (!gameInfo.teams.firstTeam) return;
  if (!gameInfo.teams.secondTeam) return;

  for (const receivedEvent of data?.chronology ?? []) {
    if (receivedEvent.type === 'FOUL') {
      const period = receivedEvent.period;
      if (!period) continue;
      const eventInfo = parseInfoEvent(receivedEvent, { first: gameInfo.teams.firstTeam, second: gameInfo.teams.secondTeam });
      const prefix = (eventInfo.teamPrefix + 'Team') as 'firstTeam' | 'secondTeam';

      const team = gameInfo.teams[prefix];
      if (!team) continue;
      if (!team.periodFouls) team.periodFouls = [];
      if (team.periodFouls[period] === undefined) {
        team.periodFouls[period] = 0;
      }
      team.periodFouls[period] += 1;
    }
  }

  return gameInfo;
}
